import { render, staticRenderFns } from "./chooseGoodsType.vue?vue&type=template&id=401585bd&scoped=true&"
import script from "./chooseGoodsType.vue?vue&type=script&lang=js&"
export * from "./chooseGoodsType.vue?vue&type=script&lang=js&"
import style0 from "./chooseGoodsType.vue?vue&type=style&index=0&id=401585bd&lang=less&scoped=true&"
import style1 from "./chooseGoodsType.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401585bd",
  null
  
)

component.options.__file = "chooseGoodsType.vue"
export default component.exports